import { IAppState } from '../../../AppModulesWrapper';

import { EServiceId } from '../../types/reducers/publishTerms';

/**
 *
 * Возвращает id выбранной карточки продвижения (топ, премиум или карточка ставки - платное или бесплатное)
 */
export function selectActiveServiceId(state: IAppState): EServiceId | null {
  return state.servicePickerWidget.publishTerms.selectedServiceId;
}
